export const DEFECT_CATEGORY_LIST_FETCH_BEGIN = "DEFECT_CATEGORY_LIST_FETCH_BEGIN";
export const DEFECT_CATEGORY_LIST_FETCH_SUCCESS = "DEFECT_CATEGORY_LIST_FETCH_SUCCESS";
export const DEFECT_CATEGORY_LIST_FETCH_FAIL = "DEFECT_CATEGORY_LIST_FETCH_FAIL";